export default __webpack_public_path__ + "static/media/fallingSlowly.a8a5ac8c.png";